import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './css/booking077c.css';
import './css/bootstrap077c.css';
import './css/custom_script3e78.css';
import './css/template077c.css';
import './css/custom_script3e78.css';
import './css/template077c.css';
import './css/woocommerce077c.css';
import './css/post-13c722.css';
import './css/post-18add2.css';
import './css/post-20d385.css';
import './css/post-23d50e.css';
import './css/post-27ce69.css';
import './css/post-29ec6a.css';
import './css/post-33fb6d.css';
import './css/post-35c6de.css';
import './css/post-207c722.css';
import './css/post-216c619.css';
import './css/post-225cbf.css';
import './css/post-254bdb.css';
import './css/post-265c08.css';
import './css/post-865c722.css';
import './css/post-866c722.css';
import './css/post-867c722.css';
import './css/post-869c722.css';
import './css/post-980e3f2.css';
import './css/post-1023a699.css';
import './css/post-3481a5.css';
import './css/post-5706d56.css';
import './css/post-19249d.css';
import './css/post-21611b.css';
import './css/post-909716b.css';
import './css/post-981716b.css';
import './css/post-994249d.css';
import './css/post-999249d.css';
import './css/post-2004854.css';
import './css/post-2097301.css';
import './css/post-4984854.css';
import './css/post-6054399.css';
import './css/post-8790098.css';
import './css/frontend.minb175.css';
import './css/widget-divider.minb175.css';
import './css/widget-google_maps.minb175.css';
import './css/widget-heading.minb175.css';
import './css/widget-icon-box.minb175.css';
import './css/widget-icon-list.minb175.css';
import './css/widget-image.minb175.css';
import './css/widget-progress.minb175.css';
import './css/widget-social-icons.minb175.css';
import './css/widget-spacer.minb175.css';
import './css/widget-text-editor.minb175.css';
import './css/woocommerce077c.css';
import './css/style.css';
import './css/all.min.css';
import './css/animate.min.css';
import './css/bootstrap-select.min.css';
import './css/bootstrap.min.css';
import './css/custom-animate.css';
import './css/jarallax.css';
import './css/nouislider.min.css';
import './css/nouislider.pips.css';
import './css/odometer.min.css';
// import './css/owl.carousel.min.css';
import './css/owl.theme.default.min.css';
import './css/stylesheet.css';
import './css/swiper.min.css';
import './css/tevily-responsive.css';
import './css/tevily.css';
import './css/timePicker.css';
import './css/tiny-slider.min.css';
import './css/twentytwenty.css';
import './css/vegas.min.css';
// import './css/style.css';
// import './css/style.css';
// import './css/style.css';
// import './css/style.css';
// import './css/style.css';
// import './css/style.css';
// import './css/style.css';
// import './css/style.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
